import { c as _c } from "react/compiler-runtime";
import { SegmentGroup as SegmentGroupPrimitive } from '@ark-ui/react/segment-group';
import { cn } from 'cn';
type SegmentGroupProps = React.ComponentProps<typeof SegmentGroupPrimitive.Root>;
export function SegmentGroup(props) {
  const $ = _c(17);
  let children;
  let className;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      className,
      children,
      orientation: t0,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t0;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t0 = $[4];
  }
  const orientation = t0 === undefined ? "horizontal" : t0;
  let t1;
  if ($[5] !== className) {
    t1 = cn("flex items-start data-horizontal:gap-4 data-horizontal:border-b data-vertical:flex-col data-vertical:gap-1 data-vertical:border-l", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== className) {
    t2 = cn("border-foreground data-horizontal:bottom-0 data-horizontal:w-(--width) data-horizontal:translate-y-px data-horizontal:border-b-2 data-vertical:h-(--height) data-vertical:-translate-x-px data-vertical:border-l-2", className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <SegmentGroupPrimitive.Indicator data-slot="segment-group-indicator" className={t2} />;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== children || $[12] !== orientation || $[13] !== rest || $[14] !== t1 || $[15] !== t3) {
    t4 = <SegmentGroupPrimitive.Root data-slot="segment-group" data-orientation={orientation} orientation={orientation} className={t1} {...rest}>{t3}{children}</SegmentGroupPrimitive.Root>;
    $[11] = children;
    $[12] = orientation;
    $[13] = rest;
    $[14] = t1;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}
type SegmentGroupItemProps = React.ComponentProps<typeof SegmentGroupPrimitive.Item>;
export function SegmentGroupItem(props) {
  const $ = _c(14);
  let children;
  let className;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t0;
  if ($[4] !== className) {
    t0 = cn("cursor-pointer font-medium text-muted-foreground transition-colors hover:text-accent-foreground data-checked:text-foreground data-disabled:cursor-not-allowed data-disabled:text-muted-foreground data-disabled:opacity-50 data-horizontal:px-1 data-horizontal:pb-3 data-vertical:px-3 data-vertical:py-1.5", className);
    $[4] = className;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== children) {
    t1 = <SegmentGroupPrimitive.ItemText>{children}</SegmentGroupPrimitive.ItemText>;
    $[6] = children;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SegmentGroupPrimitive.ItemControl />;
    t3 = <SegmentGroupPrimitive.ItemHiddenInput />;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  let t4;
  if ($[10] !== rest || $[11] !== t0 || $[12] !== t1) {
    t4 = <SegmentGroupPrimitive.Item data-slot="segment-group-item" className={t0} {...rest}>{t1}{t2}{t3}</SegmentGroupPrimitive.Item>;
    $[10] = rest;
    $[11] = t0;
    $[12] = t1;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}